var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var AlegacioFilter = /** @class */ (function (_super) {
    __extends(AlegacioFilter, _super);
    function AlegacioFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.EXP = '';
        _this.NUMDENUNCIA = '';
        _this.INFRACCIO = null;
        _this.DATAPLEC = null;
        _this.AGENTE = '';
        _this.TIPO = '';
        _this.codUser = null;
        return _this;
    }
    return AlegacioFilter;
}(FilterData));
export { AlegacioFilter };
